import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leftArrow",
  "use": "icon-leftArrow-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-leftArrow\">\n<title>leftArrow</title>\n<path d=\"M22.975 2.049l-13.951 13.951 13.951 13.951z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol